import {
  BarChart3, Settings, PenTool, Library, Flame, Film, Users, Shield, Route, FolderOpen, ClipboardList, Grid3x3, CalendarDays, Boxes, BellRing,
} from 'lucide-react';

/* Trainer-led nav. Post-split (Feb 2026): Editors author content; Trainers
 * deliver it. Trainers get read-only access to Content + Question Banks
 * — they need to browse what's available before launching live sessions —
 * with write actions gated inside each page via hasRole('editor'). Live +
 * Analytics open to trainer+. */
export const NAV_GROUPS = [
  {
    label: 'CONTENT',
    minRole: 'trainer',
    items: [
      { to: '/editor/modules', icon: PenTool, label: 'Content',          minRole: 'trainer' },
      { to: '/editor/banks',   icon: Library, label: 'Question Banks',   minRole: 'trainer' },
      { to: '/editor/library/videos', icon: Film, label: 'Video Library', minRole: 'editor' },
      { to: '/editor/library/courses', icon: Boxes, label: 'Course Packages', minRole: 'trainer' },
      { to: '/paths',          icon: Route,   label: 'Learning Paths', minRole: 'viewer' },
      { to: '/documents',      icon: FolderOpen, label: 'Documents',    minRole: 'viewer' },
    ],
  },
  {
    label: 'DELIVER',
    minRole: 'trainer',
    items: [
      { to: '/editor/live',    icon: Flame,     label: 'Live Sessions',  minRole: 'trainer' },
      { to: '/trainees',       icon: Users,     label: 'Trainees',       minRole: 'trainer' },
      { to: '/assignments',    icon: ClipboardList, label: 'Assignments', minRole: 'viewer' },
      { to: '/skills',         icon: Grid3x3,   label: 'Skill Matrix',   minRole: 'viewer' },
      { to: '/calendar',       icon: CalendarDays, label: 'Calendar',    minRole: 'viewer' },
      { to: '/notifications',  icon: BellRing,  label: 'Notifications',  perm: 'notifications.view' },
      { to: '/analytics',      icon: BarChart3, label: 'Analytics',      minRole: 'trainer' },
    ],
  },
  {
    label: 'ADMIN',
    items: [
      { to: '/audit',    icon: Shield,   label: 'Audit Log', perm: 'settings.logs' },
      { to: '/settings', icon: Settings, label: 'Settings',
        permAny: ['settings.users', 'settings.branding', 'settings.org', 'settings.logs',
                  'settings.notifications', 'settings.departments', 'settings.storage'] },
    ],
  },
];

export function filterVisibleGroups(groups, hasRole, hasPermission) {
  const itemVisible = (i) => {
    if (i.permAny) return i.permAny.some((p) => hasPermission(p));
    if (i.perm) return hasPermission(i.perm);
    return hasRole(i.minRole);
  };
  return groups
    .map(g => ({ ...g, items: g.items.filter(itemVisible) }))
    .filter(g => g.items.length > 0 && (!g.minRole || hasRole(g.minRole) || g.label === 'ADMIN'));
}

export function isItemActive(item, pathname) {
  if (item.exact) return pathname === item.to;
  if (pathname === item.to || pathname.startsWith(item.to + '/')) return true;
  if (item.to === '/analytics' && pathname.startsWith('/trainer/analytics')) return true;
  return false;
}
